import type { Messages } from './de.js';
import { editor } from './pl/editor.js';
import { model } from './pl/model.js';
import { server } from './pl/server.js';

export const pl: Messages = {
  common: {
    cancel: 'Anuluj',
    done: 'Gotowe',
    ok: 'OK',
    close: 'Zamknij',
    copy: 'Kopiuj',
    delete: 'Usuń',
    open: 'Otwórz',
    rename: 'Zmień nazwę „{name}”',
    renameAction: 'Zmień nazwę',
    retry: 'Spróbuj ponownie',
    loading: 'Wczytywanie …',
    name: 'Nazwa',
    email: 'E-mail',
    password: 'Hasło',
    unexpectedError: 'Wystąpił nieoczekiwany błąd.',
    language: 'Język',
  },
  app: {
    tagline: 'Planowanie hal i powierzchni',
    disclaimer:
      'Projekt koncepcyjny/wstępny – nie stanowi projektu wykonawczego, budowlanego ani konstrukcyjnego.',
    loadingEditor: 'Wczytywanie edytora …',
    updateAvailable: 'Dostępna jest nowa wersja. Najpierw zapisz zmiany.',
    reload: 'Odśwież',
    later: 'Później',
  },
  inspect: {
    toggle: 'Tylko podgląd',
    title:
      'Projekty tylko do podglądu: zmiany, miniatury i czas pracy nie są zapisywane, sesje na żywo nie są otwierane.',
    status: 'Tylko podgląd – nic nie jest zapisywane',
    blocked: 'Włączony tryb tylko podglądu: nic nie jest zapisywane.',
  },
  auth: {
    login: 'Zaloguj się',
    logout: 'Wyloguj się',
    createAccount: 'Utwórz konto',
    newAccount: 'Załóż nowe konto',
    haveAccount: 'Mam już konto',
    registrationPending:
      'Dziękujemy! Rejestracja została przyjęta. Zalogować się można, gdy administrator zatwierdzi konto.',
    approvalNotice: 'Nowe konta zatwierdza administrator.',
    registrationClosed: 'Dostęp przyznaje administrator. Zapytania na adres info@ltt-3d.de.',
    accessCode: 'Kod dostępu',
    accessCodeContinue: 'Dalej',
    accessCodeHint: 'Kod dostępu otrzymają Państwo od nas. Zapytania na adres info@ltt-3d.de.',
  },
  password: {
    change: 'Zmień hasło',
    current: 'Obecne hasło',
    new: 'Nowe hasło (min. {min} znaków)',
    repeat: 'Powtórz nowe hasło',
    mismatch: 'Oba nowe hasła nie są identyczne',
    changed: 'Hasło zostało zmienione. Na innych urządzeniach trzeba zalogować się ponownie.',
  },
  share: {
    button: 'Udostępnij',
    title: 'Udostępnij projekt',
    hint: 'Zaproszone osoby muszą mieć konto InduSketch. Edytorzy planują razem, oglądający mogą przeglądać projekt i chodzić po nim.',
    owner: 'Właściciel',
    you: '(ty)',
    roles: { editor: 'Może edytować', viewer: 'Tylko podgląd' },
    roleAria: 'Rola: {name}',
    emailLabel: 'Adres e-mail',
    invite: 'Zaproś',
    remove: 'Usuń',
    confirmRemove: 'Odebrać dostęp użytkownikowi {name}?',
    leave: 'Opuść projekt',
    confirmLeave: 'Opuścić projekt „{name}”? Stracisz do niego dostęp.',
    noMembers: 'Projekt nie jest jeszcze nikomu udostępniony.',
    readOnly: 'Tylko podgląd – ten projekt jest dla Ciebie tylko do odczytu.',
    sharedBy: 'Udostępnił(a): {name}',
    access: { owner: 'Właściciel', editor: 'Edytor', viewer: 'Tylko podgląd' },
    status: { project: 'w projekcie', online: 'online w InduSketch', offline: 'offline' },
    call: 'Zadzwoń',
    callAria: 'Zadzwoń: {name}',
    callAll: 'Zadzwoń do wszystkich',
    onlineElsewhere: {
      one: '{n} osoba jest online, ale nie w projekcie',
      few: '{n} osoby są online, ale nie w projekcie',
      many: '{n} osób jest online, ale nie w projekcie',
      other: '{n} osoby są online, ale nie w projekcie',
    },
  },
  game: {
    title: 'Inspekcja nadchodzi!',
    start: 'Gra: Inspekcja nadchodzi!',
    intro:
      'Jedna osoba jest inspektorem BHP, pozostali to pracownicy, którzy chowają się w hali. Kogo inspektor zobaczy z bliska, ten jest złapany. Kto zbierze kask, kamizelkę i obuwie ochronne, jest bezpieczny przez 15 sekund. Podczas gry nie można niczego edytować.',
    inspector: 'Inspektor',
    random: 'Losowo',
    duration: 'Czas gry',
    minutes: { one: '{n} minuta', other: 'Minuty: {n}' },
    go: 'Start',
    noHall: 'Do gry potrzebna jest hala z wystarczającą wolną powierzchnią.',
    needPlayers: 'Do gry potrzebna jest co najmniej jeszcze jedna osoba w projekcie.',
    roleInspector: 'Jesteś inspektorem',
    roleStaff: 'Jesteś pracownikiem',
    spectator: 'Oglądasz',
    phaseHiding: 'Chowanie się',
    phaseHunting: 'Trwa inspekcja',
    gate: 'Zgłoszenie na portierni …',
    gateHint: 'Pracownicy się chowają. Zaraz możesz ruszać.',
    hideHint: 'Schowaj się, inspektor zaraz przyjdzie!',
    huntInspector: 'Znajdź pracowników: kogo zobaczysz z bliska, ten jest złapany.',
    huntStaff:
      'Zbierz kask, kamizelkę i obuwie ochronne: w pełnym wyposażeniu jesteś bezpieczny przez 15 sekund.',
    caught: 'Złapany! Na szkolenie BHP.',
    immune: 'Przepisowo wyposażony: jeszcze {s} s bezpieczeństwa',
    free: 'wolny',
    caughtShort: 'złapany',
    protectedShort: 'chroniony',
    ppe: { helmet: 'Kask', vest: 'Kamizelka', shoes: 'Obuwie ochronne' },
    winInspector: 'Inspektor złapał wszystkich!',
    winStaff: 'Pracownicy przetrwali inspekcję!',
    again: 'Jeszcze raz',
    end: 'Zakończ grę',
    endConfirm: 'Zakończyć grę dla wszystkich?',
    you: '(ty)',
  },
  mouse: {
    title: 'Mysz i nawigacja',
    wheel: 'Kółko myszy',
    zoomSpeed3d: 'Szybkość powiększania 3D',
    zoomSpeed2d: 'Szybkość powiększania planu 2D',
    zoomToCursor: 'Powiększaj do kursora (3D)',
    zoomToCursorHint: 'Kółko powiększa w stronę punktu pod kursorem zamiast środka widoku.',
    orbitSelection: 'Obracaj wokół zaznaczonego elementu (3D)',
    orbitSelectionHint:
      'Kliknięty element staje się środkiem obrotu; dwukrotne kliknięcie przybliża go na cały widok.',
    orbitSkipLarge: 'Pomijaj działki, hale, budynki biurowe i posadzki',
    orbitSkipLargeHint:
      'Gdy są zaznaczone, środkiem obrotu pozostaje punkt pod kursorem – kliknięcie obok obiektu nie powoduje już odskoku przybliżenia.',
    invertWheel: 'Odwróć kierunek kółka',
    layout: 'Układ',
    bothPanels: 'Pokazuj oba panele boczne jednocześnie',
    bothPanelsHint:
      'Wyłączone: na tablecie otwarty jest tylko jeden panel boczny, aby plan i widok 3D miały więcej miejsca.',
    drag: 'Przeciąganie myszą',
    rotateSpeed: 'Obracanie widoku 3D',
    panSpeed: 'Przesuwanie widoku 3D',
    lookSpeed: 'Rozglądanie się podczas chodzenia',
    percent: '{pct} %',
    hint: 'Ustawienia dotyczą tego urządzenia i tej przeglądarki.',
    reset: 'Przywróć domyślne',
  },
  live: {
    online: { one: '{n} osoba w projekcie', other: 'Osoby w projekcie: {n}' },
    follow: 'Śledź widok: {name}',
    jumpTo: 'Przejdź do: {name}',
    stopFollow: 'Zakończ śledzenie',
    following: 'Śledzisz: {name}',
    disconnected: 'Utracono połączenie na żywo – ponowne łączenie …',
    reconnected: 'Połączenie na żywo przywrócone.',
    resynced: 'Zmiana nie pasowała już do aktualnego stanu i została odrzucona.',
    walking: 'chodzi po hali',
    viewing2d: 'w planie 2D',
    viewing3d: 'w 3D',
  },
  chat: {
    button: 'Czat',
    title: 'Czat projektu',
    close: 'Zamknij czat',
    minimize: 'Zminimalizuj czat',
    expand: 'Otwórz czat',
    unread: {
      one: '{n} nieprzeczytana wiadomość',
      few: '{n} nieprzeczytane wiadomości',
      many: '{n} nieprzeczytanych wiadomości',
      other: '{n} nieprzeczytanych wiadomości',
    },
    placeholder: 'Napisz wiadomość … (Enter wysyła, Shift+Enter nowa linia)',
    send: 'Wyślij',
    attach: 'Dołącz plik',
    shareView: 'Udostępnij widok',
    shareViewTitle: 'Wyślij obraz bieżącego widoku 3D – inni mogą przejść do tego widoku',
    sharingView: 'Zapisywanie widoku …',
    dictate: 'Dyktuj',
    dictateTitle:
      'Nagraj wiadomość głosową (po niemiecku, angielsku lub polsku) – kliknij ponownie, aby zakończyć, Esc anuluje',
    dictateStop: 'Zakończ dyktowanie ({time})',
    transcribing: 'Rozpoznawanie mowy …',
    dictationEmpty: 'Nic nie zrozumiano – powiedz to jeszcze raz.',
    toPlan: 'Wróć do planu',
    placeholderShort: 'Wiadomość …',
    download: 'Pobierz',
    closeImage: 'Zamknij obraz',
    zoomHint: 'Dotknij dwukrotnie, aby powiększyć',
    uploading: 'Przesyłanie … {percent} %',
    jumpToView: 'Przejdź do widoku',
    older: 'Wczytaj starsze wiadomości',
    empty: 'Brak wiadomości. Napisz pierwszą – zostanie automatycznie przetłumaczona.',
    notShared: 'Udostępnij projekt, aby inni mogli czytać, odpowiadać i rozmawiać.',
    translatedFrom: 'przetłumaczono z języka {lang}',
    showOriginal: 'Pokaż teksty oryginalne',
    original: 'Oryginał',
    showTranslation: 'Pokaż tłumaczenie',
    delete: 'Usuń wiadomość',
    deleteConfirm: 'Na pewno usunąć tę wiadomość?',
    you: 'Ty',
    dropHint: 'Upuść pliki tutaj',
    call: 'Rozmowa',
    callRunning: 'Rozmowa trwa',
    callParticipants: 'Uczestnicy: {names}',
    callNoProtocol: 'Brak protokołu – nic nie zostało przetłumaczone.',
    callShow: {
      one: 'Pokaż {n} zdanie',
      few: 'Pokaż {n} zdania',
      many: 'Pokaż {n} zdań',
      other: 'Pokaż {n} zdań',
    },
    callHide: 'Ukryj protokół',
    languages: { de: 'niemieckiego', en: 'angielskiego', pl: 'polskiego' },
  },
  call: {
    title: 'Rozmowa głosowa z tłumaczem',
    button: 'Rozmowa',
    join: 'Dołącz do rozmowy',
    start: 'Rozpocznij rozmowę',
    joining: 'Łączenie …',
    connecting: 'łączenie …',
    direct: 'bezpośrednio',
    relayed: 'przez przekaźnik',
    leave: 'Rozłącz',
    mute: 'Wycisz',
    unmute: 'Włącz mikrofon',
    speaks: 'Mój język',
    hears: 'Słyszę w języku',
    original: 'Słysz cicho oryginał',
    provider: 'Tłumacz',
    providers: {
      gemini: 'Gemini – szybki, głos jak mówca',
      deepl: 'DeepL – terminy fachowe, stały głos',
    },
    noProvider: 'Brak skonfigurowanego tłumacza – słyszycie się w oryginale.',
    members: {
      one: '{n} osoba w rozmowie',
      few: '{n} osoby w rozmowie',
      many: '{n} osób w rozmowie',
      other: '{n} osób w rozmowie',
    },
    consent:
      'Rozmowa jest tłumaczona i zapisywana jako protokół w czacie projektu. Wszyscy członkowie projektu mogą go czytać.',
    consentOk: 'Zgadzam się, dołącz',
    cancel: 'Anuluj',
    status: {
      off: 'Tłumaczenie niepotrzebne',
      connecting: 'Łączenie z tłumaczem …',
      on: 'Tłumacz aktywny',
      error: 'Tłumacz niedostępny',
    },
    micDenied: 'Brak dostępu do mikrofonu – zezwól na niego w przeglądarce.',
    needsLive: 'Rozmowy działają tylko w udostępnionych projektach z połączeniem na żywo.',
    lostLive: 'Połączenie zostało przerwane – dołącz ponownie.',
    interpreterLost: 'Tłumacz utracił połączenie.',
    providerChanged: '{name} przełączył(a) wszystkich na {provider}.',
    providerForAll: 'Dotyczy wszystkich w rozmowie.',
    fallbackOriginal: 'Teraz słyszycie się w oryginale.',
    peerFailed: 'Połączenie niemożliwe – sieć je blokuje. Ponowna próba …',
    headphones: 'Wskazówka: najlepiej brzmi ze słuchawkami.',
    titleShort: 'Rozmowa głosowa',
    settings: 'Języki i tłumacz',
    incoming: '{name} dzwoni',
    running: 'Trwa rozmowa: {names}',
    accept: 'Odbierz',
    decline: 'Odrzuć',
    later: 'Później',
    acceptNote: 'Dołączając, zgadzasz się na tłumaczenie rozmowy i zapis protokołu w czacie.',
    notificationBody: 'Odbierz lub odrzuć w projekcie',
    ringAgain: 'Zadzwoń ponownie',
    ringing: 'dzwoni …',
    ringingElsewhere: 'dzwoni (w innej części InduSketch) …',
    offline: 'niedostępny',
    incomingProject: '{name} dzwoni – projekt „{project}”',
    acceptSwitch:
      'Odebranie przełącza do tego projektu; otwarty projekt zostanie najpierw zapisany.',
    callEnded: 'Rozmowa już się zakończyła.',
    declined: 'odrzucił(a)',
    notInCall: 'nie w rozmowie',
    nobodyOnline:
      'Nikogo innego nie ma teraz w projekcie. Kto go otworzy, zobaczy informację o rozmowie.',
    you: 'Ty',
    speaking: 'mówi',
  },
  projects: {
    title: 'Projekty',
    admin: 'Administracja',
    newPlaceholder: 'Nazwa nowego projektu, np. „Hala Północ”',
    projectName: 'Nazwa projektu',
    create: 'Nowy projekt',
    import: 'Importuj projekt',
    importing: 'Importowanie …',
    importHint: 'Otwórz wyeksportowany plik InduSketch jako nowy projekt',
    search: 'Szukaj …',
    searchLabel: 'Szukaj projektów',
    sort: 'Sortowanie',
    sortUpdated: 'Ostatnio zmienione',
    sortName: 'Nazwa',
    loading: 'Wczytywanie projektów …',
    empty: 'Brak projektów.',
    noMatch: 'Brak wyników.',
    variantsOf: 'Warianty projektu {name}',
    newName: 'Nowa nazwa projektu',
    changed: 'Zmieniono {date}',
    variant: 'Wariant',
    confirmDelete: 'Czy na pewno usunąć projekt „{name}”?',
    actions: 'Akcje dla „{name}”',
    createVariant: 'Utwórz wariant',
    variants: {
      one: '{n} wariant',
      few: '{n} warianty',
      many: '{n} wariantów',
      other: '{n} wariantu',
    },
    emptyTitle: 'Brak projektów',
    emptyHint:
      'Wpisz nazwę powyżej i wybierz „Nowy projekt” – albo zaimportuj wyeksportowany plik InduSketch.',
    userMenu: 'Menu użytkownika',
    activeNow: 'Teraz edytuje: {names}',
  },
  assets: {
    title: 'Moje modele 3D',
    empty: 'Brak własnych modeli. Przeciągnij tutaj plik GLB lub go wgraj.',
    upload: 'Wgraj model',
    uploading: 'Wgrywanie …',
    dropHint: 'Upuść tutaj plik GLB',
    dimensions: 'Szerokość × głębokość × wysokość',
    actions: 'Akcje dla „{name}”',
    triangles: {
      one: '{n} trójkąt',
      few: '{n} trójkąty',
      many: '{n} trójkątów',
      other: '{n} trójkąta',
    },
    newName: 'Nowa nazwa',
    confirmDelete: 'Usunąć model „{name}”?',
    unused: 'Nie jest używany w żadnym projekcie.',
    usedIn: 'Jest nadal używany w:',
    placeholderAfter: 'W jego miejscu pojawi się zastępczy prostopadłościan tej samej wielkości.',
  },
  topbar: {
    toProjects: 'Do listy projektów',
    toggleTools: 'Pokaż/ukryj narzędzia',
    toggleProperties: 'Pokaż/ukryj właściwości',
    more: 'Więcej',
    unsaved: 'Niezapisane zmiany',
    unsavedShort: 'niezapisane',
    view: 'Widok',
    plan2d: 'Plan 2D',
    view3d: '3D',
    top: 'Z góry',
    front: 'Z przodu',
    side: 'Z boku',
    fit: 'Pokaż wszystko',
    findFar: 'Najdalszy element',
    findFarTitle:
      'Przechodzi do elementu leżącego najdalej na zewnątrz (np. przypadkowo odłożonego daleko); kliknij ponownie, aby przejść do następnego',
    farFound: '{name}: {distance} {reference} ({k} z {n})',
    farReference: {
      sites: 'poza działką',
      buildings: 'od budynków',
      center: 'od środka projektu',
    },
    farNone: 'Wszystkie elementy leżą na działce lub przy budynkach.',
    undo: 'Cofnij',
    undoTitle: 'Cofnij (Ctrl+Z)',
    redo: 'Ponów',
    redoTitle: 'Ponów (Ctrl+Y)',
    versions: 'Wersje',
    versionsTitle: 'Historia wersji',
    pdf: 'PDF',
    pdfTitle: 'Utwórz raport projektowy PDF',
    export: 'Eksport',
    exporting: 'Eksport …',
    exportTitle: 'Eksportuj projekt jako plik (wraz z własnymi modelami 3D), np. aby go przekazać',
    save: 'Zapisz',
    saving: 'Zapisywanie …',
    saveError: 'Nie zapisano – ponowna próba wkrótce',
    conflict: 'Konflikt',
    pending: 'Zmiany …',
    savedAt: 'Zapisano {time}',
  },
  versions: {
    title: 'Historia wersji',
    labelPlaceholder: 'Opis, np. „Uzgodnienie z wykonawcą hali”',
    labelAria: 'Opis wersji',
    create: 'Zapisz wersję',
    loading: 'Wczytywanie wersji …',
    empty: 'Brak wersji. Automatyczne kopie zapasowe powstają podczas zapisywania.',
    auto: 'Automatyczna kopia zapasowa',
    autoShort: 'Automatyczna',
    meta: '{date} · {user} · stan {revision}',
    restore: 'Przywróć',
    confirmRestore:
      'Przywrócić wersję „{label}”? Bieżący stan zostanie najpierw zapisany jako wersja.',
    saveFirst: 'Najpierw zapisz zmiany lub rozwiąż konflikt.',
    delete: 'Usuń wersję',
    confirmDelete: 'Trwale usunąć wersję „{label}”?',
    prune: 'Usuń automatyczne kopie starsze niż {days} dni ({n})',
    confirmPrune:
      'Trwale usunąć wszystkie automatyczne kopie starsze niż {days} dni? Nazwane wersje zostaną zachowane.',
    pruned: {
      one: 'Usunięto {n} kopię.',
      few: 'Usunięto {n} kopie.',
      many: 'Usunięto {n} kopii.',
      other: 'Usunięto {n} kopii.',
    },
  },
  conflict: {
    title: 'Projekt został w międzyczasie zmieniony',
    text: 'Ktoś (lub inna karta) zapisał ten projekt po jego otwarciu przez Ciebie. Twoje zmiany nie zostały jeszcze zapisane i nic nie zostało nadpisane.',
    saveCopy: 'Zapisz moją wersję jako kopię',
    loadServer: 'Wczytaj stan z serwera (odrzuć moje zmiany)',
    overwrite: 'Mimo to nadpisz',
    copyName: '{name} (kopia)',
  },
  admin: {
    title: 'Administracja',
    back: '← Projekty',
    tabs: 'Sekcje',
    tabUsers: 'Użytkownicy',
    tabProjects: 'Projekty',
    tabAssets: 'Modele',
    tabAudit: 'Dziennik',
    tabPrices: 'Ceny',
    pricesIntro:
      'Ceny jednostkowe (netto, €) i narzuty kalkulacji. Każdy projekt liczy według katalogu domyślnego lub wybranego i może sam nadpisać pojedyncze ceny. Puste pola używają wartości orientacyjnej.',
    pricesCatalogs: 'Katalogi cen',
    pricesDefaultBadge: 'Domyślny',
    pricesCopy: '+ Utwórz kopię',
    pricesCopyName: 'Kopia {name}',
    pricesName: 'Nazwa',
    pricesCountry: 'Kraj',
    pricesIsDefault: 'Domyślny dla wszystkich projektów bez własnego wyboru',
    pricesItem: 'Pozycja',
    pricesGuide: 'Wartość orientacyjna',
    pricesCatalogPrice: 'Cena katalogowa',
    pricesSave: 'Zapisz katalog',
    pricesDelete: 'Usuń katalog',
    pricesConfirmDelete:
      'Usunąć katalog cen „{name}”? Projekty, które go wybrały, będą liczone według katalogu domyślnego.',
    pricesSaved: 'Zapisano',
    pricesUnsaved: 'Niezapisane zmiany',
    pricesCatalog: 'Katalog',
    pricesUnitPrices: 'Ceny jednostkowe',
    pricesSurcharges: 'Narzuty',
    tabActivity: 'Aktywność',
    colLastActive: 'Ostatnio aktywny',
    never: 'nigdy',
    activitySummary: 'Przegląd użytkowników',
    activityTimeline: 'Przebieg',
    colDevice: 'Urządzenie',
    colLocation: 'Miejsce',
    colIp: 'Adres IP',
    colWorkGroup: 'Czas pracy',
    col30Group: 'Ostatnie 30 dni',
    colWork7: '7 dni',
    colWork30: '30 dni',
    colLogins: 'Logowania',
    colFailed: 'Nieudane próby',
    online: 'Teraz aktywny',
    activeIn: 'teraz w „{project}”',
    sortBy: 'Sortuj według',
    sortAsc: 'rosnąco',
    sortDesc: 'malejąco',
    colUser: 'Użytkownik',
    colEvent: 'Zdarzenie',
    activityKinds: {
      login: 'Logowanie',
      logout: 'Wylogowanie',
      'login-failed': 'Nieudana próba',
      work: 'Sesja pracy',
    },
    workIn: '{duration} w „{project}”',
    workPlain: '{duration} w edytorze',
    minutes: '{n} min',
    hoursMinutes: '{h} h {m} min',
    activityEmpty: 'Nie zarejestrowano jeszcze aktywności.',
    activityNote:
      'Rejestrowane są logowania, wylogowania, nieudane próby i aktywny czas pracy w edytorze. Wpisy są automatycznie usuwane po {days} dniach. Geolokalizacja IP: DB-IP.com (CC BY 4.0).',
    filterActivity: 'Szukaj po nazwie, e-mailu, miejscu lub IP …',
    filterActivityAria: 'Filtruj aktywność',
    pending: 'Oczekuje na zatwierdzenie ({n})',
    registered: 'zarejestrowano {date}',
    approve: 'Zatwierdź',
    reject: 'Odrzuć',
    confirmReject: 'Odrzucić rejestrację {email}? Konto zostanie usunięte.',
    confirmReset: 'Wygenerować nowe hasło dla {email}? Dotychczasowe przestanie działać.',
    newPassword: 'Nowe hasło',
    accountCreated: 'Konto utworzone',
    oneTimePassword:
      'Hasło jednorazowe dla {email}. Jest wyświetlane tylko teraz – przekaż je w bezpieczny sposób. Po zalogowaniu użytkownik może je zmienić w „Zmień hasło”.',
    colName: 'Nazwa',
    colEmail: 'E-mail',
    colRole: 'Rola',
    colProjects: 'Projekty',
    colSince: 'Od',
    colStatus: 'Status',
    roleAdmin: 'Administrator',
    roleUser: 'Użytkownik',
    disabled: 'zablokowane',
    active: 'aktywne',
    ownAccount: 'własne konto',
    makeUser: 'Zmień na użytkownika',
    makeAdmin: 'Zmień na administratora',
    unlock: 'Odblokuj',
    lock: 'Zablokuj',
    resetPassword: 'Resetuj hasło',
    addUser: '+ Dodaj użytkownika',
    createUser: 'Dodaj użytkownika',
    role: 'Rola',
    createAndPassword: 'Utwórz i wygeneruj hasło',
    filterProjects: 'Szukaj po projekcie lub właścicielu …',
    filterProjectsAria: 'Filtruj projekty',
    colProject: 'Projekt',
    colOwner: 'Właściciel',
    colRevision: 'Stan',
    colSize: 'Rozmiar',
    colChanged: 'Zmieniono',
    uploading: 'Wgrywanie …',
    uploadSystem: 'Dodaj model do biblioteki systemowej (GLB)',
    colModel: 'Model',
    colLibrary: 'Biblioteka',
    colDimensions: 'Wymiary (S × G × W)',
    colUploaded: 'Wgrano',
    system: 'System',
    auditEmpty: 'Brak wpisów.',
    statUsers: 'Aktywni użytkownicy',
    statPending: 'Oczekujące zatwierdzenia',
    statProjects: 'Projekty',
    statModels: 'Modele',
    statStorage: 'Pamięć (modele i projekty)',
    filterUsers: 'Szukaj po nazwie lub e-mailu …',
    filterUsersAria: 'Filtruj użytkowników',
    userActions: 'Akcje dla {email}',
    systemLibrary: 'Biblioteka systemowa',
    userModels: 'Modele użytkowników',
    noUserModels: 'Użytkownicy nie wgrali jeszcze własnych modeli.',
    noSystemModels: 'Biblioteka systemowa jest jeszcze pusta.',
    uploadedBy: '{name} · {date}',
    showMore: 'Pokaż kolejne ({n})',
    colTime: 'Czas',
    colAdmin: 'Administrator',
    colAction: 'Akcja',
    colTarget: 'Cel',
    colDetails: 'Szczegóły',
    colActor: 'Wykonał(a)',
    filterAudit: 'Szukaj po osobie, akcji lub celu …',
    filterAuditAria: 'Filtruj dziennik',
    allActions: 'Wszystkie akcje',
    actionFilter: 'Filtruj według akcji',
    loadOlder: 'Wczytaj starsze wpisy',
    targetTypes: {
      project: 'Projekt',
      user: 'Użytkownik',
      asset: 'Model',
      'price-catalog': 'Katalog cen',
    },
    detailRole: 'Rola: {role}',
    detailWith: 'z {name}',
    detailRevision: 'od stanu {n}',
    detailDefault: 'jako domyślny',
    detailLocked: 'zablokowano',
    detailUnlocked: 'odblokowano',
    detailApproved: 'zatwierdzono',
    actions: {
      'project.update': 'Zmieniono projekt',
      'project.live': 'Edycja na żywo',
      'project.meta': 'Zmieniono nazwę projektu',
      'project.delete': 'Usunięto projekt',
      'project.restore': 'Przywrócono wersję',
      'project.share': 'Udostępniono projekt',
      'project.unshare': 'Cofnięto udostępnienie',
      'asset.delete': 'Usunięto model',
      'asset.system-upload': 'Wgrano model systemowy',
      'user.update': 'Zmieniono użytkownika',
      'user.create': 'Utworzono użytkownika',
      'user.reject': 'Odrzucono rejestrację',
      'user.password-reset': 'Zresetowano hasło',
      'price-catalog.create': 'Utworzono katalog cen',
      'price-catalog.update': 'Zmieniono katalog cen',
      'price-catalog.delete': 'Usunięto katalog cen',
    },
  },
  network: {
    offline: 'Brak połączenia z serwerem',
    serverError: 'Błąd serwera ({status})',
    invalidResponse: 'Nieoczekiwana odpowiedź serwera',
  },
  editor,
  model,
  server,
};
